import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import useMsciBanner from '@/hooks/useMsciBanner';
import useMobile from '@/hooks/useMobile';
import Iconify from '@/components/Iconify';
import MsiDetails from './MsiDetails';

export default function MsiBanner() {
  const { isMobile } = useMobile();

  const {
    bannerData,
    bannerKind,
    bannerDetails,
    openBannerDetails,
    closeBannerDetails,
    bannerTexts: { title, description, detailsTitle },
  } = useMsciBanner();

  return (
    <>
      {title && description && (
        <Box
          sx={{
            'background': 'linear-gradient(90deg, #D5E4FF 0%, #FECBF2 98.96%)',
            'padding': '11px 16px',
            'borderRadius': '8px',
            '&:hover': {
              cursor: bannerKind !== 'mci' ? 'pointer' : 'normal',
            },
          }}
          onClick={() => {
            bannerKind !== 'mci' ? openBannerDetails() : () => { };
          }}
        >
          <Stack direction="row" justifyContent="space-between">
            <Stack gap={0.5}>
              <Typography variant="subtitle3">{title}</Typography>
              <Typography variant="bodyCard">{description}</Typography>
            </Stack>
            {bannerKind !== 'mci' && (
              <IconButton size="small" onClick={openBannerDetails} sx={{ color: '#fff' }}>
                <Iconify icon="mingcute:right-line" />
              </IconButton>
            )}
          </Stack>
        </Box>
      )}
      {bannerDetails && (
        <>
          {isMobile ? (
            <Drawer
              open={open}
              onClose={closeBannerDetails}
              anchor="bottom"
              sx={{
                '& .MuiPaper-root': {
                  borderTopLeftRadius: '24px',
                  borderTopRightRadius: '24px',
                },
              }}
            >
              <MsiDetails
                data={bannerData}
                title={detailsTitle}
                onClose={closeBannerDetails}
              />
            </Drawer>
          ) : (
            <Drawer anchor="right" open={open} onClose={closeBannerDetails}>
              <MsiDetails
                data={bannerData}
                title={detailsTitle}
                onClose={closeBannerDetails}
              />
            </Drawer>
          )}
        </>
      )}
    </>
  );
}
